//!WARNING !!! Please use the index file for when you need linkOptions
import _ from 'lodash';

const linkOptions = {
  NEW_WINDOW:    '_blank',
  PARENT_WINDOW: '_parent',
  SAME_FRAME:    '_self',
};

linkOptions.ALL = _.values(linkOptions);

const linkOptionsList = [
  { text: 'New window', value: linkOptions.NEW_WINDOW },
  { text: 'Parent window', value: linkOptions.PARENT_WINDOW },
  { text: 'Same frame', value: linkOptions.SAME_FRAME },
];

export { linkOptionsList, linkOptions };
